"use strict";

module.exports = function () {
    return {
        restrict: "AE",
        replace: true,
        scope: {
            statement: "="
        },
        templateUrl: "app/funding/directives/partials/statementResidents.html"
    };
}
